var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"small-label-component",style:({height: _vm.domHieght/3.75 + 'vw', lineHeight: _vm.domHieght/3.75 + 'vw', color:_vm.txtColor, background:_vm.bgColor, border: _vm.borderColor ? '0.3vw solid' +  _vm.borderColor : 'none'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }